import { forwardRef, SyntheticEvent, useCallback, ClipboardEvent } from 'react';
import classNames from 'classnames';

import useStyles from './styles';
import { ITextField } from './types';

export function TextField({
  name,
  label,
  className,
  disabled = false,
  placeholder = '',
  value = '',
  size = 'large',
  error = null,
  mRef,
  onFocus,
  onBlur,
  onChange,
  onPaste,
}: ITextField) {
  const classes = useStyles({ size });

  const handleOnChange = useCallback(
    (ev: SyntheticEvent<HTMLInputElement>) => {
      onChange(ev.currentTarget.value);
    },
    [onChange],
  );

  const handleFocus = useCallback(() => {
    if (onFocus) {
      onFocus();
    }
  }, [onFocus]);

  const handleBlur = useCallback(
    (e) => {
      if (onBlur) {
        onBlur(e);
      }
    },
    [onBlur],
  );

  const handleOnPaste = useCallback(
    (ev: ClipboardEvent<HTMLInputElement>) => {
      onPaste && onPaste(ev.currentTarget.value);
    },
    [onPaste],
  );

  return (
    <div>
      {label && (
        <label className={classes.label} htmlFor={name}>
          {label}
        </label>
      )}
      <input
        onPaste={handleOnPaste}
        className={classNames(classes.input, { disabled: disabled, error }, className)}
        name={name}
        id={name}
        placeholder={placeholder}
        onChange={handleOnChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={value}
        ref={mRef}
        disabled={disabled}
      />

      {error && <p className={classes.errorMsg}>{error}</p>}
    </div>
  );
}

const TextFieldWithForwardedRef = forwardRef<HTMLInputElement, ITextField>((props, ref) => (
  <TextField {...props} mRef={ref} />
));
TextFieldWithForwardedRef.displayName = 'TextField';

export default TextFieldWithForwardedRef;
